import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import { ResponseProvider } from "../services/providers";
import { useSessaoAtual } from "../services/providers/sessao-atual-provider/sessao-atual-provider";
import { CadastrarPage } from "../views/pages/cadastrar-page/cadastrar-page";
import { LoginPage } from "../views/pages/login-page";
import { LoginRepresentantePage } from "../views/pages/login-representante/login-representante";
import { PrimeiroAcessoPage } from "../views/pages/primeiro-acesso/primeiro-acesso";
import { SaurusPDV } from "../views/pages/saurus-pdv/saurus-pdv";
import { PrivateRoute } from "./components/private-route";
import { RouterMain } from "./components/router-main";

export const RouterApp = () => {
    const { DefinirRota, LoginRepresentante } = useSessaoAtual()
    const path = window.location.pathname
    switch (path) {
        case '/saurus-v4':
            DefinirRota('/saurus-v4')
            break;
        case '/saurus-mobile':
            DefinirRota('/saurus-mobile')
            break;
        case '/saurus-pdv':
            DefinirRota('/saurus-pdv')
            break;
        case '/touchone':
            DefinirRota('/touchone')
            break;
    }

    return (
        <ResponseProvider>
            <Router>
                <Switch>
                    <PrivateRoute exact path="/login" isPrivate={false} checkIsInactive={true}>
                        <LoginPage />
                    </PrivateRoute>
                    <PrivateRoute exact path="/cadastrar" isPrivate={false} checkIsInactive={false}>
                        <CadastrarPage />
                    </PrivateRoute>
                    <PrivateRoute exact path="/representante" isPrivate={false} checkIsInactive={false}>
                        <LoginRepresentantePage />
                    </PrivateRoute>
                    <PrivateRoute isPrivate={false} checkIsInactive={false}>
                        <RouterMain />
                    </PrivateRoute>
                </Switch>
                <Route path="/">
                    <Redirect to="/saurus-pdv" />
                </Route>
            </Router>
        </ResponseProvider>
    )
}